'use es6';

const makeEarlyRequest = ({
  apiUrl,
  earlyRequestKey,
  callback = null
}) => {
  window.unsubscribeQuickFetch.makeEarlyRequest(earlyRequestKey, {
    contentType: 'application/json',
    dataType: 'json',
    timeout: 15000,
    type: 'GET',
    url: window.unsubscribeQuickFetch.getApiUrl(apiUrl),
    whenFinished() {
      if (callback !== null) {
        const promise = window.unsubscribeQuickFetch.getRequestStateByName(earlyRequestKey);
        callback(promise.data);
      }
    }
  });
};
export default makeEarlyRequest;